var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},_vm._l((_vm.routes),function(r){return _c('router-link',{key:r.path,attrs:{"to":r.path}},[_vm._v(_vm._s(r.name))])}),1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }